import React from 'react';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { makeStyles, Grid } from '@material-ui/core';
import Bellocchio from '../../../shared/assets/bellocchio.png';
import Guglielmi from '../../../shared/assets/guglielmi.png';
import PoliticheAttiveIT from '../../../shared/assets/Politiche_sociali_IT.png';
import PoliticheAttiveEN from '../../../shared/assets/Politiche_sociali_EN.png';

import { ContainerSection } from '../../../shared/components/ContainerSection';

const useStyle = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  imgStyle: {
    width: '80%',
    maxWidth: 300,

    [theme.breakpoints.down('sm')]: {
      paddingBottom: 30,
      width: '100%',
      paddingTop: 10,
    },
  },
  studioAssociatoITStyle: {
    width: '100%',
    maxWidth: 300,

    [theme.breakpoints.down('sm')]: {
      paddingBottom: 30,
      width: '120%',
      paddingTop: 10,
    },
  },
  studioAssociatoENStyle: {
    width: '120%',
    maxWidth: 320,

    [theme.breakpoints.down('sm')]: {
      paddingBottom: 30,
      width: '120%',
      paddingTop: 10,
    },
  },
}));

export const Partners = () => {
  const { i18n } = useI18next();
  const classes = useStyle();

  return (
    <ContainerSection anchor="" title="Partners">
      <Grid container>
        <Grid item xs={12} md={4}>
          {/* <div style={{
            position: 'absolute',
            position: 'fixed',
            width: '64px',
            height: '64px',
            background: 'red',
            borderRadius:' 50%',
            top: '219px',
            right: '637px',
            opacity: '0.5'
            }}/> */}
          <img className={classes.imgStyle} src={Bellocchio} alt="#" />
        </Grid>
        <Grid item xs={12} md={4}>
          <img className={classes.imgStyle} src={Guglielmi} alt="#" />
        </Grid>
        <Grid item xs={12} md={4}>
          <img
            className={
              i18n.language === 'it'
                ? classes.studioAssociatoITStyle
                : classes.studioAssociatoENStyle
            }
            src={i18n.language === 'it' ? PoliticheAttiveIT : PoliticheAttiveEN}
            alt="#"
          />
        </Grid>
      </Grid>
    </ContainerSection>
  );
};
